const optimizationTypes = { normal: "fast", fast: "real_fast", deep: "deep" };

export function optimizationCostPath(scenarioId, dialogType) {
  const optimizationType = optimizationTypes[dialogType];
  if (!optimizationType) throw new Error("Invalid optimization type");
  return `calculate/optimization_cost/${scenarioId}/${optimizationType}`;
}

export function costConfirmationError(costData) {
  if (costData.can_start === false) {
    return "An optimization is already running for this scenario.";
  }
  if (costData.credit_balance < costData.costs) {
    return "You do not have enough credits for this operation.";
  }
  return null;
}
